import { useState } from "react";

export function LabelPinField({ id, label, value, onChange, error = false, hint }: {
  id: string; label: string; value: string; onChange: (value: string) => void;
  error?: boolean; hint?: string;
}) {
  const [visible, setVisible] = useState(false);
  const describedBy = [hint ? `${id}-hint` : "", error ? "label-pin-error" : ""].filter(Boolean).join(" ");
  return <div className="anl-access-field">
    <label htmlFor={id}>{label}</label>
    <div className="anl-access-pin">
      <input id={id} type={visible ? "text" : "password"} inputMode="numeric"
        autoComplete="current-password"
        pattern="[0-9]{4}" minLength={4} maxLength={4} required
        value={value} onChange={event => onChange(event.target.value.replace(/\D/gu, "").slice(0, 4))}
        aria-invalid={error || undefined} aria-describedby={describedBy || undefined} />
      <button type="button" className="anl-access-reveal" aria-label={`${label}: ${visible ? "gizle" : "göster"}`}
        aria-pressed={visible} onClick={() => setVisible(value => !value)}>{visible ? "Gizle" : "Göster"}</button>
    </div>
    {hint ? <p className="anl-access-hint" id={`${id}-hint`}>{hint}</p> : null}
  </div>;
}
